import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=04b92c38&scoped=true&"
import script from "./BusinessType.vue?vue&type=script&lang=js&"
export * from "./BusinessType.vue?vue&type=script&lang=js&"
import style0 from "./BusinessType.vue?vue&type=style&index=0&id=04b92c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b92c38",
  null
  
)

export default component.exports